export default __webpack_public_path__ + "static/media/mwoa.1ef547ee.JPG";